export const LOCALES_RICH = {
  fr_FR: "fr_FR",
  en_US: "en_US",
} as const;
